// Turkish — scripts/translate-locale.mjs 로 생성 (en.js 기준).
// 손으로 고친 값은 다음 실행에서 덮이지 않는다 (--force 제외).
// 자리표시자({n} 등)가 어긋난 항목은 영어를 그대로 둔다.
export const tr = {
  "uploadTitle": "Fotoğraf yükle",
  "uploadHint": "Tıkla veya görselleri buraya sürükle",
  "uploadHintTouch": "Fotoğraf seçmek için dokun",
  "uploadOr": "veya",
  "takePhoto": "Fotoğraf Çek",
  "yourPhotos": "Fotoğrafların",
  "photoLabel": "Fotoğraf {n}",
  "photoCount": "{n} fotoğraf",
  "addPhoto": "Fotoğraf ekle",
  "continue": "Devam et",
  "stepLabel": "Adım {current} / {total}",
  "chooseStyle": "Bir tasarım stili seç",
  "describeCustomStyle": "Kendi stilini tarif et",
  "uploadReferenceTitle": "Referans fotoğrafı yükle",
  "uploadReferenceHint": "Yapay zeka tonunu, malzemelerini ve havasını eşleştirir — odanın fotoğrafı aynı kalır.",
  "removeReference": "Referansı kaldır",
  "cleanupOptionTidy": "Toparla",
  "cleanupOptionTidyDesc": "Mobilyaları koru; dağınıklığı, çöpü, bulaşıkları temizle",
  "cleanupOptionEmpty": "Odayı boşalt",
  "cleanupOptionEmptyDesc": "Tüm mobilya ve dekoru kaldır. Duvarlar ve zemin kalır",
  "cleanupChooseOption": "Temizlik türünü seç",
  "layoutOptionFlow": "Daha iyi akış",
  "layoutOptionFlowDesc": "Giriş ve geçiş alanlarını rahatlat — hareket etmek kolaylaşsın",
  "layoutOptionSpacious": "Daha ferah",
  "layoutOptionSpaciousDesc": "Görüş açılarını aç ve kalabalığı azalt — daha geniş görünsün",
  "planChooseOption": "Kat planından ne oluşturalım?",
  "planOption_3d": "3D kat planı",
  "planOption_3dDesc": "Tüm evin kuş bakışı, döşenmiş hali",
  "planOption_room": "Tek bir oda",
  "planOption_roomDesc": "Plandaki bir odayı boya ve göz hizasından gör",
  "planOption_clean": "Planı netleştir",
  "planOption_cleanDesc": "Taslak veya bulanık bir plan düzgünce çizilir",
  "planCleanKindTitle": "Çizim türü",
  "planCleanKind_line": "Siyah-beyaz",
  "planCleanKind_color": "Renkli plan",
  "planStyleTitle": "Stil",
  "planRoomTitle": "Hangi oda?",
  "planRoomSignIn": "Plandan oda seçmek için giriş yap.",
  "planRoomPaint": "Plandaki odayı boya",
  "planRoomPicked": "Oda seçildi",
  "planRoomRepaint": "Tekrar boya",
  "planRoomClear": "Temizle",
  "planRoomNamePlaceholder": "Veya oda adını yaz (örn. ebeveyn yatak odası)",
  "planCropHint": "Daha doğru bir sonuç için fotoğrafı sadece kat planı kalacak şekilde kırp.",
  "planFirstOnly": "Kat planı olarak sadece ilk fotoğraf kullanılır.",
  "planRoomPickTitle": "Bir oda seç",
  "planRoomPickHint": "Görmek istediğin odanın üzerini boya. Kabaca boyaman yeterli.",
  "planRoomPickDone": "Bu odayı kullan",
  "planRoomNeedPick": "Planda bir odayı boya veya adını yaz.",
  "errNotFloorplan": "Bu bir kat planına benzemiyor. Kat planı yükle veya bir stil seç.",
  "planRoomFrom": "Plandan seçilen oda",
  "planInputLabel": "Kat planı",
  "planOutput_plan_3d": "3D kat planı",
  "planOutput_plan_room": "Oda görünümü",
  "planOutput_plan_clean": "Net plan",
  "planOutput_plan_color": "Renkli plan",
  "planRoomFromResult": "Odayı gör",
  "planRoomMake": "Bu odayı oluştur",
  "planRoomMeta": "{n} kredi · aynı evdeki bu oda göz hizasında",
  "layoutChooseOption": "Yeniden düzenleme türünü seç",
  "creditEarnHint": "Her gün giriş yaparak (+1) veya arkadaş davet ederek (her biri +5) kredi kazan.",
  "languageHint": "Tasarım analizinde de kullanılır.",
  "reuseStyle": "— Geçmiş bir stili tekrar kullan —",
  "customPlaceholder": "İstediğin iç mekan stilini tarif et (örn. 'sıcak ahşap tonlu huzurlu kulübe', 'metalik detaylı futuristik minimalist')",
  "customStylePublicHint": "Özel stil metinleri toplulukta anonim olarak görünebilir. Hesabım ayarlarından bunu kapatabilirsin.",
  "communityRankTitle": "Popüler stiller",
  "communityPeople": "{n} kişi kullandı",
  "customStylesChip": "Özel stiller",
  "galleryRecentBadge": "Az önce kullanıldı",
  "timeJustNow": "az önce",
  "timeAgoMin": "{n}dk önce",
  "timeAgoHour": "{n}sa önce",
  "communityViewAll": "Tümünü gör",
  "galleryTitle": "Popüler stiller",
  "briefsLabel": "Haberler",
  "briefTopupKicker": "Krediler",
  "briefTopupTitle": "Sonraki tasarım için yeterli kredi yok",
  "briefTopupLine": "Ücretsiz kredilerin yarın yenileniyor. Şimdi mi lazım? Paket al.",
  "briefSeasonKicker": "Sezonda",
  "briefSeasonTitle": "{name} geldi",
  "briefSeasonLine": "Sezona özel bir tarz — sadece birkaç hafta geçerli.",
  "briefInviteKicker": "Davet et",
  "briefInviteTitle": "Bir arkadaşını davet et — ikiniz de +{n} kredi kazanın",
  "briefInviteLine": "Bağlantını paylaş. Kaydolduklarında krediler gelir.",
  "galleryEmpty": "Henüz trend olan bir şey yok — insanlar stilleri kullandıkça burada görünecek.",
  "galleryBuiltinTitle": "Bu aralar en çok kullanılan stiller",
  "galleryPopularCustom": "Bu aralar popüler özel stiller",
  "galleryDiscoverTitle": "Özel stilleri keşfet",
  "galleryShuffle": "Karıştır",
  "galleryTranslate": "Çevir",
  "galleryTranslating": "Çevriliyor…",
  "galleryOriginal": "Orijinalini göster",
  "galleryLiveTab": "Canlı",
  "galleryLiveWaiting": "Yeni stiller bekleniyor…",
  "galleryLiveTitle": "Şu anda kullanılıyor",
  "galleryRecentCustom": "Son özel stiller",
  "galleryUse": "Bu stili kullan",
  "styleShareNotice": "Özel stil metinleri toplulukta anonim olarak görünebilir.",
  "styleShareNoticeSettings": "Ayarlardan kapat",
  "styleShareNoticeOk": "Anladım",
  "communityTopTitle": "Popüler özel stiller",
  "communityRecentTitle": "Başkalarının az önce kullandıkları",
  "communityUses": "{n} kez kullanıldı",
  "communityDesigns": "{n} tasarım",
  "communityDesignsOne": "{n} tasarım",
  "styleShareTitle": "Özel stilleri paylaş",
  "styleShareDesc": "Yazdığın özel stil metinlerini başkaları keşfetsin ve denesin. Fotoğrafların asla paylaşılmaz.",
  "additionalRequests": "Ek istekler",
  "optional": "(isteğe bağlı)",
  "additionalPlaceholder": "{style} tasarımın için özel bir isteğin var mı? (örn. 'ahşap sehpa ekle', 'vurgu rengi olarak turkuaz kullan')",
  "addAdditionalRequest": "+ Özel istek ekle",
  "generateDesign": "Tasarım Oluştur",
  "back": "Geri",
  "generatingOne": "Yapay zeka iç mekan tasarımını oluşturuyor…",
  "generatingMany": "Yapay zeka odan için {n} uyumlu tasarım oluşturuyor…",
  "generatingOneExterior": "Yapay zeka dış mekan tasarımını oluşturuyor…",
  "generatingManyExterior": "Yapay zeka {n} uyumlu dış mekan tasarımı oluşturuyor…",
  "generatingOneGarden": "Yapay zeka bahçe tasarımını oluşturuyor…",
  "generatingManyGarden": "Yapay zeka {n} uyumlu bahçe tasarımı oluşturuyor…",
  "generationFailed": "Oluşturma başarısız",
  "tryAgain": "Tekrar dene",
  "errNoInternet": "İnternet bağlantısı yok. Lütfen ağını kontrol edip tekrar dene.",
  "errTimeout": "Yapay zeka yanıt vermekte gecikti. Lütfen tekrar dene.",
  "errTooMany": "Çok fazla istek gönderildi. Lütfen biraz bekleyip tekrar dene.",
  "errNetwork": "Ağ hatası. Lütfen bağlantını kontrol edip tekrar dene.",
  "errAI": "Yapay zeka tasarım servisinde bir sorun oluştu. Lütfen tekrar dene.",
  "errFileType": "Desteklenmeyen dosya türü. Lütfen JPEG, PNG veya WebP görseli yükle.",
  "errFileTooLarge": "Dosya çok büyük. Lütfen 20MB altında bir görsel yükle.",
  "errPhotoRead": "Fotoğraf okunamadı. Lütfen başka bir fotoğraf dene.",
  "errCameraAccess": "Kameraya erişilemiyor. Lütfen Ayarlar'dan kamera erişimine izin ver.",
  "errCameraCapture": "Fotoğraf çekilemedi. Lütfen tekrar dene.",
  "errCaptionSave": "Açıklama kaydedilemedi. Lütfen tekrar dene.",
  "imageUnavailable": "Görsel kullanılamıyor",
  "designShareText": "archelier ile yapılan bu {style} tasarımına göz at",
  "altPhoto": "Fotoğraf {n}",
  "altOriginal": "Orijinal {n}",
  "altGenerated": "Tasarım {n}",
  "errInvalidSpace": "Bu görsel bir alan olarak algılanamadı. Duvar ve zemini birlikte veya odanın bir köşesini gösteren bir fotoğraf kullan.",
  "pickAnotherPhoto": "Başka bir fotoğraf seç",
  "errCustomStyle": "Lütfen özel stilini tanımla.",
  "errSignIn": "Giriş yapılamadı. Lütfen tekrar dene.",
  "errInsufficientCredits": "Kredin bitti. Günlük bonusun için yarın tekrar gel.",
  "creditCostHint": "{n} fotoğraf {c} kredi harcar — fotoğraf başına {p}.",
  "errCreditsShort": "Bunun için {need} kredi gerekiyor, sende {have} var. Bir fotoğraf çıkar veya daha fazlası için arkadaşını davet et.",
  "credits": "Krediler",
  "creditsOne": "{n} kredi",
  "creditsMany": "{n} kredi",
  "outOfCredits": "Kredin bitti",
  "creditModalTitle": "Daha fazla kredi al",
  "creditModalDesc": "Günlük kredilerin yarın yenileniyor. Beklemeden daha fazlasını ister misin?",
  "creditModalWallDesc": "Bugünün ücretsiz tasarımları bitti. Yarın {n} tane daha gelecek — veya şimdi kredi yükleyip devam et.",
  "errOutOfCreditsToday": "Bugünlük kredin bitti. Yarın {n} ücretsiz tasarım daha gelecek — veya devam etmek için kredi yükle.",
  "lastFreeHint": "Bu, bugünün son ücretsiz tasarımıydı. Yarın {n} tane daha.",
  "lastFreeHintCta": "Şimdi kredi yükle",
  "creditModalChatFree": "Tasarımcın Gio ile sohbet etmek hep ücretsiz.",
  "creditModalGuestTitle": "Tasarlamaya devam etmek için giriş yap",
  "creditModalGuestDesc": "Giriş yaparak her gün ücretsiz kredi kazanabilir, tasarımlarını kaydedip paylaşabilirsin.",
  "creditOptionSignIn": "Giriş yap ve devam et",
  "creditOptionSignInDesc": "Google veya Apple ile saniyeler içinde başla",
  "creditOptionInvite": "Bir arkadaşını davet et",
  "creditOptionInviteDesc": "Kaydolduklarında ikiniz de +{n} kredi kazanırsınız",
  "comingSoon": "Yakında",
  "close": "Kapat",
  "getAppTitle": "archelier",
  "getAppDesc": "Kendi alanını uygulamada yeniden tasarla",
  "getAppCta": "İndir",
  "appGateTitle": "Uygulamada devam et",
  "appGateDesc": "Tasarlamak en çok uygulamada keyifli — kamera, kayıtlı tasarımlar ve daha hızlı sonuçlar.",
  "appGateCta": "Uygulamayı indir",
  "appGateNotNow": "Şimdi değil",
  "dailyBonusHint": "Her gün {n} ücretsiz kredi kazanırsın.",
  "creditsAria": "{n} kredi kaldı",
  "accountCreditsTitle": "Krediler",
  "creditsDailyLabel": "Günlük, gece yarısı sıfırlanır",
  "creditsBonusLabel": "Bonus, süresi asla dolmaz",
  "creditsResetHint": "Her gün {n} ücretsiz kredi kazanırsın. Davetlerden gelen bonus krediler sen kullanana kadar kalır.",
  "creditsInviteCta": "+{n} kredi için arkadaşını davet et",
  "creditsTopUpCta": "Kredi satın al",
  "inviteMenu": "Arkadaşlarını davet et",
  "profileShare": "Paylaş",
  "profileShareText": "{name} kullanıcısının archelier üzerindeki tasarımlarına göz at.",
  "original": "Orijinal",
  "aiDesign": "Yapay Zeka Tasarımı",
  "imageGenFailed": "Bu fotoğraf için görsel oluşturulamadı",
  "seeAnalysis": "Aşağıdaki tasarım analizine göz at.",
  "analysisTitle": "İç Mekan Tasarım Analizi",
  "spaceAnalysis": "Mekan Analizi",
  "styleDescription": "Stil Açıklaması",
  "colorPalette": "Renk Paleti",
  "furnitureRec": "Mobilya Önerileri",
  "shopFor": "{item} için alışveriş",
  "shopShort": "Alışveriş",
  "paintMatch": "En yakın boya rengi",
  "paintCodeCopy": "Boya kodunu kopyala",
  "paintCodeCopied": "Kod kopyalandı",
  "editRegion": "Bir bölümü düzenle",
  "editRegionTitle": "Bu tasarımı düzenle",
  "editRegionDesc": "Yapay zekaya neyi değiştireceğini ve yerine ne koyacağını söyle. Odanın kalanı aynı kalır.",
  "editRegionBrushHint": "Yapay zekaya neyi değiştireceğini veya ekleyeceğini söyle. Belli bir yeri değiştirmek için önce üzerini fırçala, yoksa tüm resmi düzenler. Bir şeyi kaldırmak için üzerini fırçala ve \"kaldır\" yaz.",
  "editRegionMeta": "Yeni tasarım olarak kaydedildi · {n} kredi",
  "editedFromBanner": "Bu düzenlenmiş bir kopya.",
  "viewOriginal": "Orijinali gör",
  "editsOfThisDesign": "Bu tasarımın düzenlemeleri",
  "editsOfThisDesignDesc": "Bu tasarımın bazı bölümlerini düzenleyerek oluşturduğun tasarımlar.",
  "chatTitle": "Yapay zeka tasarım danışmanı",
  "chatHint": "Bu oda hakkında sorular sor. Yapay zeka tasarımını görür ve ona sadık kalır.",
  "chatStart": "Sohbet başlat",
  "chatPlaceholder": "Bir mobilya, renk veya düzen fikri sor…",
  "chatSend": "Gönder",
  "chatSending": "Düşünüyor…",
  "chatSuggestion1": "Bu odayı hangi lamba daha sıcak gösterir?",
  "chatSuggestion2": "Buranın daha ferah hissettirmesini nasıl sağlarım?",
  "chatSuggestion3": "İlk olarak hangi 3 şeyi değiştirmeliyim?",
  "chatTurnsRemaining": "Bu tasarım için {n} mesaj hakkın kaldı",
  "chatTurnsExhausted": "Bu tasarım için sohbet sınırına ulaştın. Sohbet etmeye devam etmek için yeni bir tasarım başlat.",
  "chatErrGeneric": "Danışman yanıt veremedi. Lütfen tekrar dene.",
  "chatPro": "Pro — sınırsız sohbet",
  "chatRetry": "Tekrar dene",
  "commentsTitle": "Yorumlar",
  "commentPlaceholder": "Yorum ekle",
  "commentPost": "Paylaş",
  "commentPosting": "Paylaşılıyor…",
  "commentSignInHint": "Yorum yapmak için giriş yap.",
  "commentEmpty": "Henüz yorum yok.",
  "commentDelete": "Sil",
  "commentDeleteConfirm": "Bu yorum silinsin mi?",
  "commentTooLong": "Yorumlar 500 karakterle sınırlıdır.",
  "commentErrGeneric": "Yorum gönderilemedi. Lütfen tekrar dene.",
  "commentCount": "{n}",
  "bookmarksTitle": "Koleksiyonlarım",
  "tabDesigns": "Tasarımlar",
  "tabCollections": "Koleksiyonlar",
  "bookmarksSectionTitle": "Kaydedilen tasarımlar",
  "bookmarksEmpty": "Henüz koleksiyon yok. Pano oluşturmak için bir tasarım kaydet.",
  "bookmarksAdd": "Kaydet",
  "bookmarksAdded": "Kaydedildi",
  "bookmarksRemove": "Kaydedilenlerden çıkar",
  "bookmarksSignInHint": "Tasarımları kaydetmek için giriş yap.",
  "saved": "Kaydedildi",
  "savedCollectionDefault": "Kaydedilenler",
  "follow": "Takip et",
  "unfollow": "Takibi bırak",
  "following": "Takip ediliyor",
  "followers": "Takipçiler",
  "followingTab": "Takip edilenler",
  "followingEmpty": "En son tasarımlarını burada görmek için kişileri takip et.",
  "followersEmpty": "Henüz takipçi yok.",
  "followingEmpty2": "Henüz kimse takip edilmiyor.",
  "followSignInHint": "Takip etmek için giriş yap",
  "cannotFollowSelf": "Kendini takip edemezsin.",
  "profile": "Profil",
  "profileNotFound": "Bu profil bulunamadı.",
  "profileDesigns": "Tasarımlar",
  "profileDesignsCount": "Tasarım",
  "profileFollowers": "Takipçi",
  "profileFollowing": "Takip Edilen",
  "profileBio": "Biyografi",
  "profileEdit": "Profili düzenle",
  "profileMyProfile": "Profilim",
  "displayNameLabel": "Görünen ad",
  "displayNamePlaceholder": "Adın veya stüdyon (isteğe bağlı)",
  "displayNameSave": "Adı kaydet",
  "displayNameSaved": "Ad kaydedildi",
  "displayNameErrGeneric": "Ad kaydedilemedi. Lütfen tekrar dene.",
  "handleLabel": "Kullanıcı adı",
  "handlePlaceholder": "küçük harf, rakam, alt çizgi (3-20 karakter)",
  "handleSave": "Kullanıcı adını kaydet",
  "handleSaved": "Kullanıcı adı kaydedildi",
  "handleInvalid": "Kullanıcı adı 3-20 karakter olmalı: a-z, 0-9, alt çizgi.",
  "handleTaken": "Bu kullanıcı adı zaten alınmış.",
  "handleErrGeneric": "Kullanıcı adı kaydedilemedi. Lütfen tekrar dene.",
  "bioPlaceholder": "Kendinden bahset (en fazla 200 karakter)",
  "bioSave": "Biyografiyi kaydet",
  "bioSaved": "Biyografi kaydedildi",
  "bioErrGeneric": "Biyografi kaydedilemedi. Lütfen tekrar dene.",
  "instagramLabel": "Instagram",
  "instagramPlaceholder": "instagram_kullanici_adin",
  "instagramInvalid": "Sadece harf, rakam, nokta veya alt çizgi kullan (en fazla 30).",
  "profileNoDesigns": "Henüz tasarım yok.",
  "collections": "Koleksiyonlar",
  "collectionsTab": "Koleksiyonlar",
  "collectionMine": "Koleksiyonlarım",
  "collectionEmpty": "Henüz koleksiyon yok.",
  "collectionPublicEmpty": "Herkese açık koleksiyon yok.",
  "collectionItemCount": "{n} öge",
  "collectionEmpty2": "Bu koleksiyon boş.",
  "newCollection": "Yeni koleksiyon",
  "collectionNamePlaceholder": "Koleksiyon adı (örn. Oturma odası fikirleri)",
  "collectionCreate": "Oluştur",
  "collectionDelete": "Koleksiyonu sil",
  "collectionDeleteConfirm": "Bu koleksiyon silinsin mi? Ögeler kaldırılacak.",
  "collectionRename": "Koleksiyonu yeniden adlandır",
  "collectionVisibility": "Herkese açık koleksiyon",
  "collectionVisibilityOn": "Bağlantıya sahip herkes görebilir",
  "collectionVisibilityOff": "Bu koleksiyonu sadece sen görebilirsin",
  "addToCollection": "Koleksiyona ekle",
  "saveToCollection": "Koleksiyona kaydet",
  "collectionAdded": "Eklendi",
  "collectionRemoveFromBoard": "Koleksiyondan çıkar",
  "collectionShareLink": "Koleksiyon bağlantısını kopyala",
  "collectionByOwner": "hazırlayan:",
  "collectionNotFound": "Bu koleksiyon mevcut değil veya gizli.",
  "collectionErrCreate": "Koleksiyon oluşturulamadı.",
  "collectionErrSave": "Koleksiyon güncellenemedi.",
  "collectionDone": "Tamam",
  "collectionPickerHint": "Bu tasarımı eklemek veya çıkarmak için bir koleksiyona dokun.",
  "uploadAcceptsHint": "Fotoğraflar en iyi sonucu verir; ancak çizimler, görünüşler, kat planları ve 3D ekran görüntüleri de uygundur.",
  "examplePhotos": "Örnek fotoğraflar",
  "detectedInputTypes": {
    "sketch": "Çizim",
    "elevation": "Görünüş",
    "floorplan": "Kat planı",
    "3d_model": "3D model"
  },
  "floorplanDetectedBanner": "Kat planı gibi görünüyor — en büyük ortak alan göz hizasında görselleştirildi. Belirli bir odayı seçmek için bir dahaki sefere ek isteğine not ekle (örn. \"ana yatak odasını görselleştir\").",
  "floorplanDetectedBannerWithRoom": "Kat planı gibi görünüyor — {room} göz hizasında görselleştirildi. Farklı bir oda seçmek için bir dahaki sefere ek isteğine not ekle.",
  "spaceCategoryTitle": "Ne tasarlıyorsun?",
  "spaceCategories": {
    "interior": "İç mekan",
    "exterior": "Dış Mekan",
    "garden": "Bahçe"
  },
  "exteriorStyles": {
    "halloween": {
      "name": "Cadılar Bayramı",
      "description": "Oymalı bal kabakları, fenerler, gizemli sonbahar verandası"
    },
    "christmas": {
      "name": "Yılbaşı",
      "description": "Çelenkler, sıcak ışıklar, çam dalı süsleri"
    },
    "lunar_new_year": {
      "name": "Ay Yeni Yılı",
      "description": "Kırmızı fenerler, altın detaylar, uğurlu yazılar"
    },
    "spring_blossom": {
      "name": "Bahar Çiçekleri",
      "description": "Çiçek açan ağaçlar, pastel bitkiler, taze ışık"
    },
    "modern_facade": {
      "name": "Modern Cephe",
      "description": "Yalın geometri, geniş camlar, karma malzemeler"
    },
    "modern_farmhouse": {
      "name": "Modern Farmhouse",
      "description": "Beyaz kaplama, siyah detaylar, ahşap dokular"
    },
    "mediterranean": {
      "name": "Akdeniz",
      "description": "Sıva, terakota, kemerli açıklıklar"
    },
    "craftsman": {
      "name": "Craftsman",
      "description": "Ahşap kaplama, alçak eğimli çatılar, açık mertekler"
    },
    "contemporary": {
      "name": "Çağdaş",
      "description": "Keskin hatlar, iddialı kütleler, endüstriyel malzemeler"
    },
    "minimalist_exterior": {
      "name": "Minimalist Dış Mekan",
      "description": "Sade renk paleti, tek malzeme odağı"
    },
    "tudor": {
      "name": "Tudor",
      "description": "İngiliz Tudor stili — dik çatılı ve ahşap karkaslı"
    },
    "cape_cod": {
      "name": "Cape Cod",
      "description": "Geleneksel New England — beyaz ahşap kaplama, siyah kepenkler"
    },
    "japanese_traditional": {
      "name": "Geleneksel Japon",
      "description": "Kiremit çatılı, engawa'lı Minka tarzı ahşap iskelet"
    },
    "mountain_cabin": {
      "name": "Dağ Evi",
      "description": "Doğanın içinde A çatılı ahşap ev ya da kütük ev"
    },
    "midcentury_exterior": {
      "name": "Mid-Century Dış Mekan",
      "description": "1950-60'lar modernizmi — düz çatı, geniş camlar, yatay çizgiler"
    }
  },
  "gardenStyles": {
    "halloween": {
      "name": "Cadılar Bayramı",
      "description": "Bal kabağı tarlası, fenerler, sisli sonbahar bahçesi"
    },
    "christmas": {
      "name": "Yılbaşı",
      "description": "Işıklı çamlar, sıcak ışıklar, kış bahçesi"
    },
    "lunar_new_year": {
      "name": "Ay Yeni Yılı",
      "description": "Kırmızı fenerler, çiçekli dallar, uğurlu bahçe"
    },
    "spring_blossom": {
      "name": "Bahar Çiçekleri",
      "description": "Kiraz çiçekleri, laleler, taze bahar yeşili"
    },
    "modern": {
      "name": "Modern Bahçe",
      "description": "Geometrik hatlar, beton karolar, heykelsi süs otları"
    },
    "mediterranean": {
      "name": "Akdeniz",
      "description": "Çakıl, zeytin ve lavanta, terakota saksılar, pergola"
    },
    "coastal": {
      "name": "Sahil",
      "description": "Süs otları, deniz odunu, tuza dayanıklı bitkiler"
    },
    "minimalist": {
      "name": "Minimalist",
      "description": "Tek malzeme, sade bitki paleti, negatif alan"
    },
    "zen": {
      "name": "Zen Bahçesi",
      "description": "Taranmış çakıl, taşlar, yalın bitkiler"
    },
    "cottage": {
      "name": "Kır Bahçesi",
      "description": "Romantik, yoğun bitkiler, karma çok yıllıklar"
    },
    "desert": {
      "name": "Çöl / Kurakçıl",
      "description": "Kuraklığa dayanıklı bitkiler, sukulentler, çakıl"
    },
    "tropical": {
      "name": "Tropikal",
      "description": "Gür yeşillikler, büyük yapraklar, canlı çiçekler"
    },
    "english": {
      "name": "İngiliz Bahçesi",
      "description": "Bakımlı çimler, çitler, katmanlı bitki alanları"
    }
  },
  "seasonLabel": "Mevsim",
  "seasons": {
    "none": "Tümü",
    "spring": "İlkbahar",
    "summer": "Yaz",
    "autumn": "Sonbahar",
    "winter": "Kış"
  },
  "timeOfDayLabel": "Günün saati",
  "timesOfDay": {
    "none": "Fark etmez",
    "day": "Gündüz",
    "golden_hour": "Altın saat",
    "night": "Gece"
  },
  "editRegionReplacementLabel": "Ne değişsin?",
  "editRegionReplacementPlaceholder": "örn. kapının yanına büyük bir heykel ekle",
  "editRegionSubmit": "Düzenlemeyi oluştur",
  "editRegionGenerating": "Düzenlenen görsel oluşturuluyor…",
  "editRegionMaskRequired": "Önce değiştirmek istediğin alanı fırçala.",
  "editRegionReplacementRequired": "Oraya ne konacağını söyle.",
  "editRegionBrush": "Fırça",
  "editRegionUndo": "Geri al",
  "editRegionSize": "Boyut",
  "editRegionClear": "Sıfırla",
  "errEditGeneric": "Düzenleme başarısız. Lütfen tekrar dene.",
  "lightingPlan": "Aydınlatma Planı",
  "designTips": "Tasarım İpuçları",
  "startNew": "Yeni Tasarıma Başla",
  "viewMyDesigns": "Tasarımlarımı Gör",
  "favorite": "Favorilere ekle",
  "unfavorite": "Favorilerden çıkar",
  "rename": "Yeniden adlandır",
  "savePromptText": "Bu tasarımı kaydetmek, paylaşmak ve yenilerini yapmak için giriş yap",
  "guestCreditsLeft": "Sadece {n} ücretsiz tasarım hakkın kaldı. Giriş yap ve {total} hakla başla.",
  "guestCreditsGone": "Bu son ücretsiz tasarımındı. Giriş yap ve {total} hak kazan.",
  "signInGoogle": "Google ile Giriş Yap",
  "signInApple": "Apple ile Giriş Yap",
  "signInDesc": "Tasarımlarını kaydet ve istediğin zaman eriş.",
  "signInPopupBlocked": "Açılır pencere engellendi. Lütfen tarayıcı ayarlarından izin ver.",
  "appName": "archelier",
  "navCreate": "Oluştur",
  "navGallery": "Galeri",
  "navGio": "Tasarımcı",
  "navMain": "Ana menü",
  "packsTitle": "Kredi yükle",
  "packDesigns": "yaklaşık {n} tasarım",
  "packBuying": "Açılıyor…",
  "packWaiting": "Ödeme alındı — kredilerin ekleniyor…",
  "packDone": "Krediler eklendi.",
  "packSlow": "Kredilerin yolda. Birazdan görünecek — tekrar satın almana gerek yok.",
  "packFailed": "Satın alma tamamlanamadı. Ücret çekildiyse ve kredi gelmediyse destekle iletişime geç.",
  "gioRole": "Mekan tasarımcısı",
  "gioAiNote": "AI",
  "gioSignInBody": "Gio ile konuşmak için giriş yap. Gio oda fotoğraflarına ve geçmiş tasarımlarına bakar, stil önerir ve sohbetten tasarım yapabilir veya düzenleyebilir.",
  "gioGreeting": "Merhaba, ben Gio. Bana mekanının fotoğrafını, sevdiğin bir odanın görselini/bağlantısını ya da bir tasarımını gönder — bir yön önereyim ve senin için oluşturayım.",
  "gioChipTaste": "Benim tarzım ne?",
  "gioChipTrend": "Bu hafta neler trend?",
  "gioChipPhoto": "Oda fotoğrafı gönder",
  "gioChipMine": "Tasarımlarımdan birini getir",
  "gioTyping": "Gio düşünüyor…",
  "gioPlaceholder": "Gio'ya sor veya bir bağlantı yapıştır",
  "gioSend": "Gönder",
  "gioAttachPhoto": "Fotoğraf ekle",
  "gioPickDesign": "Tasarımlarım",
  "gioPickEmpty": "Henüz tasarım yok — önce bir tane yap, sonra buraya getir.",
  "gioRemove": "Kaldır",
  "gioToday": "Bugün",
  "gioNoCredits": "Kredin bitti.",
  "gioError": "Gio şu an yanıt veremedi. Lütfen tekrar dene.",
  "gioAlreadyStarting": "Zaten başlatılıyor — biraz bekle.",
  "gioPhotoSkipped": "Bazı fotoğraflar eklenemedi. En fazla {n} fotoğraf ekleyebilirsin (JPG, PNG, WebP veya HEIC, 20 MB altında).",
  "gioErrPhotos": "Bu işlem için fotoğraflar bulunamadı. Alanının bir fotoğrafını ekleyip tekrar dene.",
  "gioErrPrompt": "Gio bunu bir tasarıma dönüştüremedi. Biraz farklı tarif etmeyi dene.",
  "gioErrGone": "Bu tasarım veya öneri artık mevcut değil.",
  "gioCreditsLow": "{n} kredi kaldı · mesaj {c}, fotoğraflı mesaj {p}",
  "gioCreditsLowFree": "{n} kredin kaldı · Gio ile sohbet ücretsiz",
  "gioNoCreditsChatFree": "Tasarım kredin bitti — sohbet etmek hâlâ ücretsiz.",
  "gioDailyLimit": "Bugünlük bu kadar sohbet yeter. Yarın devam edelim.",
  "gioCardEdit": "Düzenle",
  "gioCardPhotos": "Fotoğraflar hazır: {n}",
  "gioCardPhotoFromDesign": "{date} tarihli tasarımından fotoğraf",
  "gioCardPhotoFromDesignNoDate": "Tasarımlarından birinden fotoğraf",
  "gioCardPhotoFromChat": "Burada paylaştığın fotoğraf",
  "gioCardPhotoNew": "Yeni fotoğraf",
  "gioCardNoPhoto": "Henüz fotoğraf yok",
  "gioCardChangePhoto": "Değiştir",
  "gioCardAddPhoto": "Fotoğraf ekle",
  "gioCardUploading": "Yükleniyor…",
  "gioCardSame": "Bu fotoğraftan zaten bir {style} tasarımın var ({date}).",
  "gioCardSameView": "Görüntüle",
  "gioCardSameHint": "Aynı isteklerle sonuç hemen hemen aynı olacaktır. Değiştirmek için yukarıya özel istekler ekle, sohbetten Gio'ya söyle veya Oluştur'da aç.",
  "gioPickPhoto": "Bir fotoğraf seç",
  "gioPickUpload": "Yeni fotoğraf yükle",
  "gioRunEdit": "Düzenle · {n} kredi",
  "gioRunGenerate": "Tasarla · {n} kredi",
  "gioRunWithPhoto": "Fotoğraf ekle ve tasarla · {n}/fotoğraf",
  "gioOpenInCreate": "Oluştur'da aç",
  "gioPaintMyself": "Alanı kendim boya",
  "gioStarting": "Başlatılıyor…",
  "gioJobMaking": "Tasarımın hazırlanıyor…",
  "gioJobEditing": "Tasarımın düzenleniyor…",
  "gioJobNotify": "Ayrılabilirsin — hazır olduğunda haber vereceğim.",
  "gioJobInvalid": "Bu fotoğraf tasarlayabileceğim bir alana benzemiyor.",
  "gioJobFailed": "Bu işlemi tamamlayamadım.",
  "gioJobRefunded": "Kredilerin iade edildi.",
  "gioJobDone": "Hazır — göz at",
  "gioJobGone": "Bu tasarım silindi.",
  "gioAskAboutDesign": "Gio'ya bu tasarımı sor",
  "navFeed": "Akış",
  "navMy": "Sayfam",
  "navAccount": "Ayarlar",
  "signIn": "Giriş Yap",
  "signOut": "Çıkış Yap",
  "deleteAccount": "Hesabı Sil",
  "deleteAccountTitle": "Hesabını silmek istiyor musun?",
  "deleteAccountWarn": "Bu işlem hesabını ve bağlı tüm verileri kalıcı olarak siler. Bu işlem geri alınamaz.",
  "deleteAccountItem_designs": "Tüm tasarımların, görsellerin ve Gio ile sohbetlerin",
  "deleteAccountItem_profile": "Profilin, kullanıcı adın ve kaydedilen stillerin",
  "deleteAccountItem_social": "Yorumlar, beğeniler, takipler ve koleksiyonlar",
  "deleteAccountItem_credits": "Satın alınanlar dahil kalan kredilerin ve abonelik geçmişin",
  "deleteAccountBilling_web": "Aktif web aboneliğin otomatik olarak iptal edilecek.",
  "deleteAccountBilling_ios": "App Store veya Google Play aboneliğin otomatik olarak iptal edilmeyecek — lütfen mağaza abonelik ayarlarından iptal et.",
  "deleteAccountFinal": "Oturumun hemen kapanacak ve bu hesabı geri getiremeyeceksin.",
  "deleteAccountConfirm": "Hesabı sil",
  "deleteAccountSubmitting": "Siliniyor…",
  "deleteAccountError": "Hesabın silinemedi. Lütfen tekrar dene.",
  "myDesigns": "Tasarımlarım",
  "language": "Dil",
  "support": "Destek",
  "terms": "Kullanım Koşulları",
  "privacy": "Gizlilik Politikası",
  "signInTerms": "Giriş yaparak {terms} ve {privacy} metinlerini kabul etmiş olursun.",
  "onboardingSkip": "Atla",
  "onboardingNext": "İleri",
  "onboardingStart": "Başla",
  "tourTitle": "archelier Turu",
  "tourCreate": "Buradan başla. Bir oda, dış cephe veya bahçe fotoğrafı çek ya da yükle, bir stil seç; yeni tasarımın anında hazır olsun.",
  "tourGallery": "Galeri — bu hafta archelier üzerinde en çok seçilen stiller. Kendi alanında denemek için birine dokun.",
  "tourGio": "Gio senin tasarımcın. Bir fotoğraf göster ve ne istediğini söyle — Gio stil önerir, ardından tasarımı senin için oluşturur veya düzenler.",
  "tourMy": "Tasarımların Sayfam sekmesinde birikir. İster bir bölümü fırçalayarak ister tarif ederek düzelt, ardından indir veya paylaş.",
  "tourStart": "Yeni bir tasarım için dilediğin zaman bu düğmeye geri dön. Hadi tek bir fotoğrafla başlayalım.",
  "tourReplay": "Turu yeniden başlat",
  "onboarding": [
    {
      "icon": "photo_camera",
      "title": "Çek, çiz veya yükle",
      "desc": "En iyi sonucu telefon fotoğrafı verir ama archelier el çizimlerini, görünüş çizimlerini, kat planlarını ve 3D model ekran görüntülerini de otomatik algılar."
    },
    {
      "icon": "style",
      "title": "19+ stil, 4 akıllı mod",
      "desc": "Hazır bir stil seç, kendi isteğini yaz, sevdiğin bir referans fotoğrafla eşleştir veya Temizleme / Yerleşim modlarıyla alanı düzenle."
    },
    {
      "icon": "brush",
      "title": "Sadece istediğin bölümü düzenle",
      "desc": "Bir köşeyi beğenmedin mi? Sonucun üzerini fırçayla boya ve yapay zekaya oraya ne koyacağını söyle. Odanın kalan kısmı birebir aynı kalır."
    },
    {
      "icon": "auto_awesome",
      "title": "Hemen dene",
      "desc": "Her gün ücretsiz kredi kazanırsın. Bir fotoğraf yükle, ilk tasarımın yaklaşık bir dakikada hazır olsun."
    }
  ],
  "onboardTabFeedTitle": "Önce göz at",
  "onboardTabFeedDesc": "Başkalarının neler yarattığını gör ve kendi alanın için ilham bul.",
  "onboardTabCreateTitle": "Yapay zeka ile tasarla",
  "onboardTabCreateDesc": "Bir fotoğraf, çizim veya plan yükle — yapay zeka yeni bir tasarım oluştursun.",
  "onboardTabMyTitle": "Kaydet ve yönet",
  "onboardTabMyDesc": "Tasarımların burada birikir. İstediğin zaman akışta paylaş veya indir.",
  "onboardTabGioTitle": "Gio'ya sor",
  "onboardTabGioDesc": "Mekan tasarımcımız Gio, fotoğraflarından stiller önerir ve doğrudan sohbet içinde tasarım yapabilir veya düzenleyebilir.",
  "myDesignsTitle": "Tasarımlarım",
  "signInToSee": "Tasarımlarını görmek için giriş yap",
  "signInToSeeDesc": "Kaydedilen tasarımların burada görünecektir.",
  "loadingDesigns": "Tasarımlar yükleniyor…",
  "errLoadDesigns": "Tasarımlar yüklenemedi. Lütfen tekrar dene.",
  "retry": "Tekrar Dene",
  "noFavorites": "Henüz favori yok.",
  "noDesigns": "Henüz tasarım yok. İlkini oluştur!",
  "createDesign": "Tasarım Oluştur",
  "loadMore": "Daha Fazla Yükle",
  "loading": "Yükleniyor…",
  "errDesignNotFound": "Tasarım bulunamadı.",
  "errLoadDesign": "Tasarım yüklenemedi.",
  "errDeleteDesign": "Silinemedi. Lütfen tekrar dene.",
  "renameTitle": "Tasarımı Yeniden Adlandır",
  "renamePlaceholders": [
    "Oturma odası yenileme v1",
    "Mutfak — aydınlık sürüm",
    "Stüdyo yenileme",
    "Yatak odası, sıcak tonlar",
    "Balkon planı B",
    "Ev-ofis düzeni",
    "Kafe iç mekan taslağı",
    "Ön bahçe v2"
  ],
  "save": "Kaydet",
  "cancel": "İptal",
  "deleteTitle": "Tasarım Silinsin mi?",
  "deleteDesc": "Bu tasarım ve tüm görselleri kalıcı olarak silinecek. Bu işlem geri alınamaz.",
  "delete": "Sil",
  "deleting": "Siliniyor…",
  "postToFeed": "Akışta paylaş",
  "postedToFeedTitle": "Akışta paylaşıldı",
  "postedToFeedDesc": "Diğer kullanıcılar artık bu tasarımı akışta görebilir ve beğenebilir.",
  "captionTitle": "Açıklama ekle",
  "captionPlaceholder": "Bu alanı neden yeniden tasarladığını paylaş (isteğe bağlı)",
  "captionEdit": "Açıklamayı düzenle",
  "captionPost": "Paylaş",
  "captionSave": "Kaydet",
  "captionCancel": "İptal",
  "viewFeed": "Akışı gör",
  "generationInProgress": "Mekanın tasarlanıyor…",
  "generationKeepBrowsing": "Göz atmaya devam edebilirsin — hazır olduğunda haber vereceğiz",
  "generationDone": "Tasarımın hazır!",
  "generationTapToOpen": "Görüntülemek için Aç'a dokun",
  "generationFailedHint": "Kredin düşülmedi. Lütfen tekrar dene.",
  "open": "Aç",
  "copy": "Kopyala",
  "copied": "Kopyalandı!",
  "share": "Paylaş",
  "downloadImages": "Yapay zeka görsellerini indir",
  "download": "İndir",
  "downloadWatermarkHint": "Sağ alt köşede küçük bir archelier imzası yer alır.",
  "modes": {
    "redesign": "Yeniden Tasarla",
    "staging": "Boş oda sahneleme"
  },
  "styleUsed": "Kullanılan Stil",
  "customDescLabel": "Özel açıklama:",
  "additionalReqLabel": "Ek istekler:",
  "useStyleAgain": "Bu stili tekrar kullan",
  "feedTitle": "Topluluk",
  "feedEmpty": "Henüz herkese açık tasarım yok. İlk sen ol!",
  "feedSortLatest": "En yeniler",
  "feedSortPopular": "Popüler",
  "feedFilterAll": "Tümü",
  "useThisStyle": "Bu stili dene",
  "sourceDesignBanner": "\"{name}\" temel alındı",
  "galleryPickBanner": "{name} ile oluşturuluyor",
  "signInToLike": "Tasarımları beğenmek için giriş yap",
  "tryApp": "archelier uygulamasını dene",
  "privateTitle": "Bu tasarım gizli",
  "privateDesc": "Tasarımın sahibi bunu herkese açık yapmadı.",
  "linkNotFoundTitle": "Bu bağlantı mevcut değil",
  "linkNotFoundDesc": "Tasarım silinmiş veya bağlantı eksik olabilir.",
  "createWithApp": "archelier ile oluştur",
  "shareViewCTA": "Kendi mekanını yeniden tasarlamak ister misin?",
  "styles": {
    "modern": {
      "name": "Modern",
      "description": "Temiz çizgiler, nötr tonlar, minimalist çağdaş"
    },
    "scandinavian": {
      "name": "İskandinav",
      "description": "Aydınlık, doğal malzemeler, sıcak Nordik dokunuşlar"
    },
    "ikea": {
      "name": "IKEA",
      "description": "Fonksiyonel, uygun fiyatlı, akıllı günlük İskandinav tasarımı"
    },
    "japandi": {
      "name": "Japandi",
      "description": "Japon minimalizmi ile İskandinav sıcaklığının buluşması"
    },
    "industrial": {
      "name": "Endüstriyel",
      "description": "Ham malzemeler, açıkta ögeler, şehirli loft estetiği"
    },
    "coastal": {
      "name": "Sahil",
      "description": "Ferah, aydınlık sahil evi şıklığı"
    },
    "classic": {
      "name": "Klasik",
      "description": "Zamansız zarafet, zengin kumaşlar, süslü detaylar"
    },
    "artdeco": {
      "name": "Art Deco",
      "description": "Cesur geometri, altın dokunuşlar, 1920'lerin ihtişamı"
    },
    "midcentury": {
      "name": "Mid-Century Modern",
      "description": "Organik formlar, sıcak ahşap, 1950-60'ların retro çekiciliği"
    },
    "maximalist": {
      "name": "Maksimalist",
      "description": "Cesur desenler, zengin katmanlar, \"ne kadar çok, o kadar iyi\" felsefesi"
    },
    "vintage": {
      "name": "Vintage",
      "description": "Nostalgik cazibe, antika dokunuşlar, sıcak retro palet"
    },
    "bohemian": {
      "name": "Bohem",
      "description": "Özgür ruhlu, renkli tekstiller, sanatsal eklektizm"
    },
    "tropical": {
      "name": "Tropikal",
      "description": "Yemyeşil bitkiler, ratan, ferah tatil havası"
    },
    "cottagecore": {
      "name": "Cottagecore",
      "description": "Romantik İngiliz kır tarzı, çiçekler, yumuşak pasteller"
    },
    "rustic": {
      "name": "Rustik",
      "description": "Doğal ahşap, taş, sıcak kır evi cazibesi"
    },
    "wabisabi": {
      "name": "Wabi-Sabi",
      "description": "Kusurlu güzellik, ham dokular, dingin Japon sadeliği"
    },
    "gothic": {
      "name": "Gotik",
      "description": "Karanlık ve dramatik, kadife, süslü siluetler"
    },
    "cyberpunk": {
      "name": "Cyberpunk",
      "description": "Neon ışıklı fütürizm, yüksek teknoloji yüzeyler, şehir distopyası"
    },
    "taisho_romance": {
      "name": "Taisho Romance",
      "description": "20. yüzyıl başı Japonya'sı ve Batı Art Nouveau uyumu"
    },
    "biophilic": {
      "name": "Biyofilik",
      "description": "Her yerde bitkiler, doğal ışık, organik dokular"
    },
    "cozy": {
      "name": "Sıcacık",
      "description": "Sıcak, yumuşak, davetkar — Hygge tarzı konfor"
    },
    "gaming": {
      "name": "Oyun Odası",
      "description": "RGB ışıklı kurulum, şık teknoloji, sürükleyici oyun köşesi"
    },
    "minimalist": {
      "name": "Minimalist",
      "description": "Sadeleşmiş, az eşya, ferah alanlar"
    },
    "mediterranean": {
      "name": "Akdeniz",
      "description": "Kireç badanalı duvarlar, terakota, kemerler, doğal taş"
    },
    "luxury": {
      "name": "Sessiz Lüks",
      "description": "Kaliteli malzemeler, yalın palet, abartısız şıklık"
    },
    "dark_academia": {
      "name": "Dark Academia",
      "description": "Dramatik kütüphane — bordo, pirinç, üst üste kitaplar"
    },
    "organic_modern": {
      "name": "Organik Modern",
      "description": "Ham doğal malzemelerle modern formlar"
    },
    "farmhouse": {
      "name": "Çiftlik Evi",
      "description": "Ahşap kaplama, geniş lavabo, eskitme ahşap, sıcak kır tarzı"
    },
    "halloween": {
      "name": "Cadılar Bayramı",
      "description": "Bal kabakları, mumlar, dramatik sonbahar havası"
    },
    "christmas": {
      "name": "Yılbaşı",
      "description": "Çam ağacı, çelenkler, sıcak ışıklar, kutlama dokunuşları"
    },
    "lunar_new_year": {
      "name": "Ay Yeni Yılı",
      "description": "Kırmızı ve altın, fenerler, uğurlu motifler"
    },
    "spring_blossom": {
      "name": "Bahar Çiçekleri",
      "description": "Kiraz çiçekleri, pasteller, taze ve ferah ışık"
    },
    "custom": {
      "name": "Özel Stil",
      "description": "Kendi özgün iç mekan vizyonunu tanımla"
    },
    "reference": {
      "name": "Referans",
      "description": "Yüklediğin bir fotoğrafın tonunu, malzemelerini ve havasını yakala"
    },
    "floorplan": {
      "name": "Kat planı",
      "description": "Kat planından 3D bir plan veya net bir çizim"
    },
    "cleanup": {
      "name": "Temizleme",
      "description": "Dağınıklığı topla veya odayı boşalt — seçim senin"
    },
    "layout": {
      "name": "Yerleşim",
      "description": "Aynı mobilyalar, daha akıllı yerleşim — rahat geçişler veya daha ferah"
    }
  },
  "langMismatchNotice": "Bu analiz {lang} dilinde oluşturuldu.",
  "pricingTitle": "İhtiyacına göre büyüyen planlar",
  "pricingSubtitle": "Ücretsiz başla. Daha fazla tasarım ve ayrıcalıklı özellikler istediğinde yükselt.",
  "pricePerMonth": "/ ay",
  "trialCta": "{n} günlük ücretsiz denemeni başlat",
  "accountPlanFreeTitle": "Hesabın ÜCRETSİZ",
  "accountPlanProTitle": "Pro planındasın",
  "accountPlanTrialTitle": "Pro planındasın — Ücretsiz Deneme",
  "proTrialBadge": "Deneme",
  "proTrialDaysLeft": "Ücretsiz denemende {n} gün kaldı",
  "proTrialIntroTitle": "2 hafta ücretsiz Pro kazan",
  "proTrialIntroDesc": "Kayıt ol ve {n} ücretsiz krediyle başla.",
  "proTrialFeatures": "Sonra her gün {n} ücretsiz kredi daha. Abonelik yok, asla.",
  "welcomeSkip": "Hesap açmadan devam et",
  "landingHeadline": "herhangi bir odayı saniyeler içinde yeniden tasarla.",
  "landingTagline": "Fotoğraf çek, stil seç, gerçekçi bir iç mekan görseli al. Her gün ücretsiz, abonelik yok.",
  "landingOpenWeb": "Ya da web'de devam et →",
  "landingFeat1": "Yapay zeka iç mekan görselleri",
  "landingFeat2": "Fotogerçekçi",
  "landingFeat3": "50+ stil",
  "landingFeat4": "Bahçe ve dış mekan",
  "landingFeat5": "Her gün ücretsiz",
  "landingStoreOn": "Şuradan indir:",
  "landingStoreGet": "Şuradan edin:",
  "lp": {
    "metaTitle": "archelier — Fotoğraftan, Çizimden veya Kat Planından Yapay Zeka İç Mimarisi",
    "metaDescription": "Bir odanın fotoğrafını çek, yaklaşık bir dakikada fotogerçekçi yeni tasarımını al. İç mekan, dış mekan ve bahçe için 48 stil, 3D kat planları, fırçayla düzenleme ve sohbet edebileceğin bir yapay zeka tasarımcı. Her gün ücretsiz.",
    "heroEyebrow": "Yapay zeka ile iç mimari",
    "scrollCue": "Nasıl çalıştığını gör",
    "webCta": "Tarayıcında ücretsiz dene",
    "orApp": "Veya uygulamayı indir",
    "qrHint": "Telefonunun kamerasıyla tara. Tasarımın hazır olduğu anda uygulama sana haber verir.",
    "showEyebrow": "Öncesi ve sonrası",
    "showTitle": "Tek bir fotoğraf. Bambaşka bir oda.",
    "showBody": "archelier ile üretilmiş gerçek sonuçlar. Karşılaştırmak için sürükle.",
    "before": "Öncesi",
    "after": "Sonrası",
    "tabRoom": "Oturma odası",
    "tabEmpty": "Boş oda",
    "tabSketch": "Çizim",
    "tabPlan": "Kat planı",
    "tabExterior": "Dış mekan",
    "capRoom": "Rustik — aynı mutfak ve oturma odası, daha sıcak bir havada.",
    "capEmpty": "İskandinav — mobilyalandırılmış boş bir oda.",
    "capSketch": "Japandi — bir taslak çizim, gerçek bir mekana dönüştürüldü.",
    "capPlan": "Kat planı modu — 2D plan, tüm evin 3D görüntüsüne dönüştürüldü.",
    "capExterior": "Minimalist — kalabalık bir mağaza cephesi, yeniden tasarlandı.",
    "howEyebrow": "Nasıl çalışır",
    "howTitle": "Üç adım, yaklaşık bir dakika.",
    "how1Title": "Fotoğraf çek",
    "how1Body": "Herhangi bir oda, olduğu gibi — ya da bir çizim, kat planı veya 3D ekran görüntüsü. Aynı odanın 3 açısına kadar.",
    "how2Title": "Bir stil seç",
    "how2Body": "48 stilden birini seç, kendi stilini tek cümleyle tarif et ya da beğendiğin bir fotoğrafı yükle.",
    "how3Title": "Tasarımını al",
    "how3Body": "Mekanının mobilya listesi, renk paleti ve aydınlatma planıyla fotogerçekçi bir görseli.",
    "stylesEyebrow": "Stiller",
    "stylesTitle": "48 stil, üç farklı mekan türü.",
    "stylesBody": "İç mekan için 28, dış mekan için 11, bahçe için 9 stil — ayrıca Cadılar Bayramı, Yılbaşı, Ay Yeni Yılı ve bahar için sezonsal görünümler.",
    "stylesInterior": "İç mekan",
    "stylesExterior": "Dış mekan",
    "stylesGarden": "Bahçe",
    "stylesCta": "Stil galerisine göz at",
    "modesEyebrow": "Stillerin ötesinde",
    "modesTitle": "Bir mekan üzerinde çalışmanın 5 yolu daha.",
    "modeCustomTitle": "Özel stil",
    "modeCustomBody": "İstediğin görünümü bir cümleyle tarif et ve sonraki sefere kaydet.",
    "modeReferenceTitle": "Referans",
    "modeReferenceBody": "Sevdiğin bir fotoğrafı yükle; yerleşimini değil, tonunu, malzemelerini ve paletini kullan.",
    "modeCleanupTitle": "Temizleme",
    "modeCleanupBody": "Dağınıklığı kaldır ve odayı yalın haliyle gör.",
    "modeLayoutTitle": "Yerleşim",
    "modeLayoutBody": "Mevcut mobilyaları değiştirmek yerine yerlerini yeniden düzenle.",
    "modePlanTitle": "Kat planı",
    "modePlanBody": "Kat planını tüm evin 3D görüntüsüne veya taslak bir çizimi temiz bir çizime dönüştür.",
    "editEyebrow": "Fırça ile düzenleme",
    "editTitle": "Her seferinde tek bir şeyi değiştir.",
    "editBody": "Sadece koltuğu mu beğenmedin? Daire içine al ve yerine ne istediğini yaz. archelier odanın kalanına dokunmadan yalnızca o alanı yeniden çizer — duvar rengi, halı, aydınlatma ve tablolar için de geçerli.",
    "editPrompt": "Eskitme deri koltuk",
    "shopTitle": "Gördüğünü satın al.",
    "shopBody": "Her tasarım bir mobilya listesi, renk paleti ve aydınlatma planıyla gelir; her parça benzer ürünlerin aramasına yönlendirir.",
    "gioEyebrow": "Gio",
    "gioTitle": "Bir tasarımcıyla detayları konuş.",
    "gioBody": "Gio, kendi sekmesinde yer alan yapay zeka mekan tasarımcın. Odanın fotoğrafını, beğendiğin bir mekanın görselini veya bağlantısını gönder. Gio doğrudan sohbet içinde bir yön önerir ve tasarımı senin için yapar.",
    "gioRole": "Mekan tasarımcısı",
    "gioUser": "Burası mutfağım ve yemek alanım. Biraz soğuk hissettiriyor. Fikrin var mı?",
    "gioReply": "Keskin yüzeyler yerine sıcak ahşap, yumuşak tekstiller ve loş ortam ışığını katmanlayalım. İşte deneyebileceğin bir yön:",
    "gioCardTitle": "Japandi sıcaklığı",
    "gioCardBody": "Doğal meşe ve dokulu sıva mekana anında sıcaklık katar.",
    "gioCardAction": "Tasarla",
    "priceEyebrow": "Fiyatlandırma",
    "priceTitle": "Her gün ücretsiz. Abonelik yok.",
    "price1": "Yerel gece yarısında yenilenen günlük ücretsiz tasarımlar",
    "price2": "Hesap oluşturduğunda bonus",
    "price3": "Bir arkadaşını davet et, ikiniz de daha fazlasını alın",
    "price4": "Daha fazlası mı lazım? Kredi paketi yükle",
    "privacyTitle": "Fotoğrafların sende kalır.",
    "privacyBody": "Fotoğrafların, komutların ve tasarımların asla yapay zeka modellerini eğitmek veya reklam için kullanılmaz. Sen paylaşmadıkça tasarımların gizli kalır.",
    "faqTitle": "Sorular",
    "faq1Q": "archelier nedir?",
    "faq1A": "archelier (Architect + Atelier), telefonun ve web için bir yapay zeka iç mimari uygulamasıdır. Kameranı bir odaya doğrult, bir stil seç ve her mobilyanın adlandırılıp bağlantılandığı, aynı mekanın fotogerçekçi yeni tasarımını al. İç mekanlar, dış mekanlar ve bahçeler için çalışır.",
    "faq2Q": "Nasıl çalışır?",
    "faq2A": "Odanın fotoğrafını çek veya bir taslak, kat planı ya da 3D ekran görüntüsü yükle. 48 stilden birini seç, kendi stilini tarif et veya bir referans fotoğraf yükle. Yaklaşık bir dakika içinde mekanının fotogerçekçi bir render'ını, mobilya listesini, renk paletini ve aydınlatma planını alırsın.",
    "faq3Q": "archelier ücretsiz mi?",
    "faq3A": "Evet. Abonelik yoktur. Herkes yerel gece yarısında yenilenen günlük ücretsiz tasarımlar kazanır; ayrıca hesap oluşturma ve arkadaş davet etme bonusu alır. Daha fazlasını istersen bir kredi paketi satın alabilirsin.",
    "faq4Q": "Bir kat planını 3D render'a dönüştürebilir mi?",
    "faq4A": "Evet. Kat planı modu, 2D kat planını seçtiğin stilde tüm evin 3D görüntüsüne dönüştürür. El çizimini veya bulanık bir planı da net bir çizime ya da renkli bir plana dönüştürebilir.",
    "faq5Q": "Sevdiğim bir fotoğrafın stilini eşleştirebilir miyim?",
    "faq5A": "Evet. Referans stilini seç ve ilham fotoğrafını yükle. archelier, düzenini kopyalamadan tonunu, malzemelerini ve paletini odana uygular.",
    "faq6Q": "Tasarımın sadece bir bölümünü değiştirebilir miyim?",
    "faq6A": "Evet. Değiştirmek istediğin alanı daire içine al (koltuk, halı, duvar) ve yerine ne istediğini yaz. Sadece o alan yeniden çizilir; odanın geri kalanı olduğu gibi kalır.",
    "faq7Q": "Gio nedir?",
    "faq7A": "Gio, archelier'in yapay zeka mekan tasarımcısıdır. Ona odanın fotoğrafını, sevdiğin bir mekanın görselini veya bağlantısını ya da kendi tasarımlarından birini gönder. Gio bir yön önerir, sohbet içinde tasarımı senin için oluşturur veya düzenler; renk, bütçe ve aydınlatma hakkındaki soruları yanıtlar.",
    "faq8Q": "Fotoğraflarım yapay zekayı eğitmek için kullanılıyor mu?",
    "faq8A": "Hayır. archelier fotoğraflarını, komutlarını veya tasarımlarını yapay zeka modellerini eğitmek ya da reklam için kullanmaz. Tasarımların sen paylaşmadıkça hesabına özel kalır.",
    "faq9Q": "archelier'ı nerede kullanabilirim?",
    "faq9A": "App Store'da, Google Play'de ve archelier.co adresinde. Hesabın ve tasarımların her yerde senkronize kalır. archelier 11 dilde mevcuttur.",
    "ctaTitle": "Odanı bugün yeniden tasarla.",
    "ctaBody": "Telefonunda ve web'de. Tasarımların her yerde senkronize kalır.",
    "langLabel": "Dil"
  },
  "upgradeToPro": "Pro'ya Yükselt",
  "creditsPerMonth": "Ayda {n} kredi",
  "planFreeName": "Ücretsiz",
  "planFreeTagline": "Her ay birkaç tasarımla archelier uygulamasını dene.",
  "planProName": "Pro",
  "planProTagline": "Kaliteli sonuçlar isteyen düzenli tasarımcılar için.",
  "planStudioName": "Studio",
  "planStudioTagline": "İleri düzey kullanıcılar, ekipler ve ticari işler için.",
  "planFeatWatermark": "\"archelier\" filigranı içerir",
  "planFeatNoWatermark": "Kaydedilen veya paylaşılan tasarımlarda filigran yok",
  "planFeatUnlimited": "Sınırsız yapay zeka tasarımı oluşturma",
  "planFeatUnlimitedChat": "Tasarım başına sınırsız yapay zeka sohbeti (ücretsiz: 3 hak)",
  "planFeatUnlimitedEdit": "Sınırsız bölüm düzenleme",
  "planFeatFeed": "Akışta paylaş",
  "planFeatEverythingPro": "Pro'daki her şey",
  "planFeatCommercial": "Ticari kullanım hakları",
  "planFeatApiAccess": "API erişimi (yakında)",
  "planCtaSubscribe": "Abone ol",
  "planCtaCurrent": "Mevcut planın",
  "planPopular": "En popüler",
  "signInToSubscribe": "Abone olmak için giriş yap",
  "signInToBuy": "Satın almak için giriş yap",
  "trialNote": "{n} günlük ücretsiz deneme",
  "creditPacksTitle": "Ya da kredi paketleriyle yükleme yap",
  "creditPacksSubtitle": "Tek seferlik satın alma, abonelik gerekmez.",
  "packStarterName": "Başlangıç Paketi",
  "packStandardName": "Standart Paket",
  "packProName": "Pro Paket",
  "packCreditsAmount": "{n} kredi",
  "packCtaBuy": "Satın al",
  "pricingFootnote": "Fiyatlar USD cinsindendir. Vergiler ödemede hesaplanır. İstediğin zaman iptal et.",
  "errBillingGeneric": "İsteğin işlenirken bir sorun oluştu. Lütfen tekrar dene.",
  "accountTitle": "Ayarlar",
  "accountPlanSection": "Abonelik",
  "accountCreditsSection": "Krediler",
  "accountCreditsDesc": "Tasarım oluştururken kredi kullanılır. İstediğin zaman yükleme yapabilirsin.",
  "viewPlans": "Planları gör",
  "changePlan": "Planı değiştir",
  "manageBilling": "Faturalandırmayı yönet",
  "manageBillingWebHint": "Web üzerinden abone olduysan archelier.co adresinden yönetebilirsin.",
  "buyCreditPack": "Kredi paketi satın al",
  "subRenewsAt": "{date} tarihinde yenilenir",
  "subEndsAt": "{date} tarihinde biter",
  "trialEndsAt": "Ücretsiz deneme {date} tarihinde biter — otomatik olarak 9,99$/ay olur",
  "trialCancelEndsAt": "Deneme {date} tarihinde biter — abonelik yenilenmeyecek",
  "subStatus_past_due": "Ödeme gecikti — lütfen ödeme yöntemini güncelle.",
  "subStatus_canceled": "Abonelik iptal edildi.",
  "subStatus_unpaid": "Abonelik ödenmedi.",
  "subStatus_trialing": "Ücretsiz deneme aktif.",
  "account": "Hesap",
  "pricing": "Fiyatlandırma",
  "upgrade": "Yükselt",
  "inviteTitle": "Arkadaşlarını davet et, kredi kazan",
  "inviteSubtitle": "Bir arkadaşın senin bağlantınla kaydolduğunda sen +{inviter}, o ise +{invitee} kredi kazanır.",
  "inviteFriends": "Arkadaşlarını davet et",
  "inviteSignInHint": "Kişisel davet bağlantını almak için giriş yap.",
  "yourReferralCode": "Davet bağlantın",
  "inviteCodeLoading": "Davet bağlantın hazırlanıyor…",
  "inviteLinkHint": "Bağlantın üzerinden yeni kaydolanlar +{n} başlangıç kredisi kazanır.",
  "copyLink": "Bağlantıyı kopyala",
  "shareLink": "Bağlantıyı paylaş",
  "inviteShareText": "archelier ile mekanını yapay zekayla yeniden tasarla. Bağlantımı kullanarak +{n} ücretsiz kredi kazan.",
  "redeemTitle": "Kodun mu var?",
  "redeemDesc": "Bonus kredi kazanmak için bir arkadaştan gelen davet kodunu veya promosyon kodunu gir.",
  "copyCode": "Kodu kopyala",
  "errRefSelf": "Kendi davet kodunu kullanamazsın.",
  "landingInviteTitle": "Bir arkadaşın seni davet etti — ikiniz de +{n} kredi kazanıyorsunuz.",
  "landingInviteAutoIos": "Uygulamayı yükle, ardından bu davet bağlantısına tekrar dokun — uygulama açılır ve kaydolduğunda bonusun eklenir.",
  "landingInviteAutoAndroid": "Aşağıdaki Google Play butonuyla yükleyip kaydol — bonusun otomatik eklenir. Eklenmezse bu kodu Ayarlar → Arkadaşlarını davet et kısmına gir.",
  "landingInviteDesktop": "Buradan kaydolduğunda bonusun hemen eklenir. Mobil uygulamada almak için QR kodunu tara ve telefonundaki adımları izle.",
  "promoTitle": "Promosyon kodun mu var?",
  "promoDesc": "Bonus kredi kazanmak için bir promosyon kodu gir.",
  "promoPlaceholder": "ör. LAUNCH2026",
  "promoRedeem": "Kullan",
  "promoSuccess": "Kullanıldı — hesabına {n} kredi eklendi.",
  "errPromoInvalid": "Bu kod geçersiz.",
  "errPromoExpired": "Bu kodun süresi doldu.",
  "errPromoMaxed": "Bu kod kullanım limitine ulaştı.",
  "errPromoUsed": "Bu kodu zaten kullandın.",
  "errPromoUserInit": "Lütfen yeniden yükle ve tekrar dene.",
  "errPromoGeneric": "Kod kullanılamadı. Lütfen tekrar dene.",
  "reportThisDesign": "Bu tasarımı bildir",
  "reportShort": "Bildir",
  "reportTitle": "Tasarımı bildir",
  "reportDesc": "Bu tasarımda ne sorun var? Bildirimini yalnızca moderatörler görür.",
  "reportReason_spam": "Spam veya reklam",
  "reportReason_nsfw": "Cinsel veya uygunsuz içerik",
  "reportReason_copyright": "Telif hakkı ihlali",
  "reportReason_other": "Diğer",
  "reportNotePlaceholder": "Detay ekle (isteğe bağlı, en fazla 500 karakter)",
  "reportSubmit": "Bildirimi gönder",
  "reportSubmitting": "Gönderiliyor…",
  "reportSignInHint": "Bildirim göndermek için lütfen giriş yap.",
  "reportThanks": "Bildirim alındı",
  "reportThanksDesc": "İnceleyip gerekiyorsa işlem yapacağız. Bildirdiğin için teşekkürler.",
  "errReportGeneric": "Bildirim gönderilemedi. Lütfen birazdan tekrar dene.",
  "blockUser": "Bu kullanıcıyı engelle",
  "unblockUser": "Engeli kaldır",
  "blockShort": "Engelle",
  "blockConfirm": "@{handle} engellensin mi? Tasarımlarını ve etkinliklerini görmezsin, onlar da seninkilerle etkileşime giremez.",
  "blockedUsersMenu": "Engellenen kullanıcılar",
  "blockedUsersTitle": "Engellenen kullanıcılar",
  "blockedUsersDesc": "Engellediğin kullanıcılar. Tasarımları akışından ve profillerden gizlenir.",
  "blockedUsersEmpty": "Henüz kimseyi engellemedin.",
  "profileBlocked": "Bu kullanıcıyı engelledin.",
  "profileBlockedAction": "Tasarımlarını tekrar görmek için engeli kaldır.",
  "errBlockGeneric": "Engel durumu güncellenemedi. Lütfen tekrar dene.",
  "errBlockedCustomCommand": "İsteğin izin verilmeyen sözcükler içeriyor.",
  "moderationAutoUnlisted": "Bu tasarım, moderasyon kontrolümüzce genel akıştan otomatik olarak kaldırıldı. Bunun bir hata olduğunu düşünüyorsan lütfen yöneticilerle iletişime geç.",
  "promptLang": "Turkish"
};
